import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { COUNTRY_MASTER_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { Observable, skipWhile, mapTo, tap } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CountryResolverServiceService   implements Resolve<any>  {

  constructor(  private store: Store) { }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> | Observable<never> {
   return this.store.select(COUNTRY_MASTER_STATE).pipe(
      skipWhile(country => !country ||country?.id=== 0),
      mapTo(true)
    )
  }
}


